import { UncontrolledTooltip } from "reactstrap";
import { SocialGroupData } from "../../../../../../Data/Applications/SocialApp/SocialApp";
import { Image, LI, UL } from "../../../../../../AbstractElements";
import { dynamicImage } from "../../../../../../Utils";

const SocialGroup = () => {
  return (
    <UL className="simple-list flex-row">
      {SocialGroupData.map((data, index) => (
        <LI className="d-inline-block" key={index}>
          <Image className="img-40 rounded-circle" src={dynamicImage(`user/${data.imageName}`)} alt="Img" id={`UncontrolledTooltipExample-${index}`}/>
          <UncontrolledTooltip placement="top" target={`UncontrolledTooltipExample-${index}`}>
            {data.userName}
          </UncontrolledTooltip>
        </LI>
      ))}
    </UL>
  );
};

export default SocialGroup;
